export default __webpack_public_path__ + "static/media/joint-head-technical.1221c80e.jpeg";